"use client";

import { Button, Icon } from "@pamperedchef/design-system";

import * as styles from "./BackToPrevious.module.scss";

// eslint-disable-next-line no-unused-vars
interface BackToPrevious {
	label?: string;
	onClick?: () => void;
}

/**
 * BackToPrevious Composite component
 */
export function BackToPrevious({
	label,
	onClick
}: BackToPrevious): JSX.Element {
	return (
		<div className={styles["back-previous"]}>
			<Button
				kind="tertiary"
				size="sm"
				className={styles["back-previous__button"]}
				onClick={() => onClick?.()}
			>
				<span>
					<Icon name="ArrowLeft" size={12} />
				</span>
				<span>{label}</span>
			</Button>
		</div>
	);
}
